import React, { useEffect } from "react";
import { partnerService } from '../../services/api/partner.service';
import { DashboardHeader } from "../main/dashboardHeader";
import { DashboardContainer } from "../main/dashboardContainer";
import { DashboardFooter } from "../main/dashboardFooter";
import { Outlet } from 'react-router-dom';
import { AppLogout } from "../main/appLogout";

export const Dashboard = () => {

    const partener = sessionStorage.getItem("idPartener")

    useEffect(() => {
        partnerService.getLocations({ partener: partener })
            .then(response => {
                if (response && response.length > 0) {
                    sessionStorage.setItem('haveLocations', true);
                }
                else {
                    sessionStorage.setItem('haveLocations', false);
                }
            })
    }, [])

    useEffect(() => {
        partnerService.getLocationsSpecialCons({ partener: partener })
            .then(response => {
                if (response && response.length > 0) {
                    sessionStorage.setItem('haveLocationsSpecialCons', true);
                }
                else {
                    sessionStorage.setItem('haveLocationsSpecialCons', false);
                }
            })
    }, [])

    return (
        <div>
            <AppLogout>
			    <DashboardHeader></DashboardHeader>
                <DashboardContainer>
                    <Outlet></Outlet>
                </DashboardContainer>
                <DashboardFooter></DashboardFooter>
            </AppLogout>
        </div>
    );
};